export default {
  LIST(state, data) {
    state.examResults = data
  },
  GET(state, data) {
    state.examResult = { ...data }
  },

  UPLOAD_EXAM_RESULT(state, data = {}) {
    state.examResult = {
      apply_doc_id: null,
      is_accepted: null,
      exam_id: null,
      direction_mark: null,
      english_mark: null,
      is_certificate: false,
      exam_ans_file: null,
      ...data,
    }
  },
}
